<!--
 * @Author: ghy
 * @Date: 2023-07-18 12:35:09
 * @LastEditors: ghy
 * @LastEditTime: 2023-07-18 14:59:03
 * @Description: 
-->
<template>
  <div class="cus-footer">
    <div class="cus-footer-content">
      <div class="cus-footer-item">
        <div>版权所有:北京市数字教育中心（北京电化教育馆）</div>
        <div><i class="icon1"></i><span>客服热线：010-82817642</span></div>
      </div>
      <div class="cus-footer-item">
        <div>技术支持：北京星立方科技发展股份有限公司</div>
        <div><i class="icon2"></i><span>QQ技术支持群：37770401</span></div>
      </div>
      <div class="cus-footer-item">
        <div>
          <span>京ICP备05039435号-1</span> <img src="@/assets/icon/gh.png"/>
          <span>京公网安备11010202010111号</span>
        </div>
        <div><i class="icon3"></i><span>邮箱：school@starscube.com</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CusFooter",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.cus-footer {
  width: 100%;
  height: 146px;
  display: flex;
  justify-content: center;
  background: #fff;
  .cus-footer-content {
    width: 1400px;
    padding: 28px 128px;
    box-sizing:  border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .cus-footer-item {
    display: flex;
    div:nth-child(1){
        width: 385px;
        font-size: 14px;
        color: #333;
        >img{
          width: 22px;
          height: 22px;
        }
    }
    div:nth-child(2){
        margin-left: 510px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color:#999;
        >i{
            display: block;
            width: 18px;
            height: 18px;
            background-image: url(../assets/icon/sprite.png);
            margin-right: 9px;
        }
        .icon1{
          background-position: -3px -2px;
        }
        .icon2{
          background-position: -3px 53px;
        }
        .icon3{
          background-position: -3px 21px;
        }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CusFooter.vue